export enum ENavigationRoute {

    Home = 'home',    
    Intervention = 'intervention',
    UserConfiguration = 'conf',
    DrawingTool = 'drawing-tool',
    Error = 'error',
}
